/* tslint:disable */
/* eslint-disable */
/**
 * DaaS
 * Data as a Service - website backend for frontend.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: maritime_support@gatehouse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ErrorMessage400,
  ErrorMessage401,
  ErrorMessage403,
  ErrorMessage404,
  ErrorMessage405,
  ErrorMessage408,
  ErrorMessage500,
  ErrorMessage503,
  ErrorMessage504,
  LoginRequest,
  LoginResponse,
  Registration,
} from '../models';
import {
  ErrorMessage400FromJSON,
  ErrorMessage400ToJSON,
  ErrorMessage401FromJSON,
  ErrorMessage401ToJSON,
  ErrorMessage403FromJSON,
  ErrorMessage403ToJSON,
  ErrorMessage404FromJSON,
  ErrorMessage404ToJSON,
  ErrorMessage405FromJSON,
  ErrorMessage405ToJSON,
  ErrorMessage408FromJSON,
  ErrorMessage408ToJSON,
  ErrorMessage500FromJSON,
  ErrorMessage500ToJSON,
  ErrorMessage503FromJSON,
  ErrorMessage503ToJSON,
  ErrorMessage504FromJSON,
  ErrorMessage504ToJSON,
  LoginRequestFromJSON,
  LoginRequestToJSON,
  LoginResponseFromJSON,
  LoginResponseToJSON,
  RegistrationFromJSON,
  RegistrationToJSON,
} from '../models';

export interface ActivateuserRequest {
  activationId: string;
}

export interface OperationIdRequest {
  loginRequest: LoginRequest;
}

export interface ReguserRequest {
  registration: Registration;
}

/**
 *
 */
export class AuthenticationApi extends runtime.BaseAPI {
  /**
   * Activate user
   */
  async activateuserRaw(
    requestParameters: ActivateuserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.activationId === null ||
      requestParameters.activationId === undefined
    ) {
      throw new runtime.RequiredError(
        'activationId',
        'Required parameter requestParameters.activationId was null or undefined when calling activateuser.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['x-api-key'] = this.configuration.apiKey('x-api-key'); // api_key authentication
    }

    const response = await this.request(
      {
        path: `/registration/{activation_id}`.replace(
          `{${'activation_id'}}`,
          encodeURIComponent(String(requestParameters.activationId))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Activate user
   */
  async activateuser(
    requestParameters: ActivateuserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.activateuserRaw(requestParameters, initOverrides);
  }

  /**
   * Delete token
   */
  async authenticationLogoutDeleteRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['x-api-key'] = this.configuration.apiKey('x-api-key'); // api_key authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        this.configuration.apiKey('Authorization'); // bearerAuth authentication
    }

    const response = await this.request(
      {
        path: `/authentication/logout`,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete token
   */
  async authenticationLogoutDelete(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.authenticationLogoutDeleteRaw(initOverrides);
  }

  /**
   * Create token
   */
  async operationIdRaw(
    requestParameters: OperationIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LoginResponse>> {
    if (
      requestParameters.loginRequest === null ||
      requestParameters.loginRequest === undefined
    ) {
      throw new runtime.RequiredError(
        'loginRequest',
        'Required parameter requestParameters.loginRequest was null or undefined when calling operationId.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['x-api-key'] = this.configuration.apiKey('x-api-key'); // api_key authentication
    }

    const response = await this.request(
      {
        path: `/authentication/login`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: LoginRequestToJSON(requestParameters.loginRequest),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LoginResponseFromJSON(jsonValue)
    );
  }

  /**
   * Create token
   */
  async operationId(
    requestParameters: OperationIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LoginResponse> {
    const response = await this.operationIdRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Register user
   */
  async reguserRaw(
    requestParameters: ReguserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.registration === null ||
      requestParameters.registration === undefined
    ) {
      throw new runtime.RequiredError(
        'registration',
        'Required parameter requestParameters.registration was null or undefined when calling reguser.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['x-api-key'] = this.configuration.apiKey('x-api-key'); // api_key authentication
    }

    const response = await this.request(
      {
        path: `/registration`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RegistrationToJSON(requestParameters.registration),
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Register user
   */
  async reguser(
    requestParameters: ReguserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.reguserRaw(requestParameters, initOverrides);
  }
}
